import { defineComponent as _defineComponent } from 'vue'
import { CodeOptionsType } from '@/components/engraving/types/oneDragTowType'
import { translate } from '@/util/commonFun'
import { Input } from 'element-ui'
import { ref, watch, withDefaults } from 'vue'

type ElInputType = Partial<InstanceType<typeof Input>>
// eslint-disable-next-line
type FunType = (field: any, value: any) => void
type option = CodeOptionsType[number]['code']

export default /*#__PURE__*/_defineComponent({
  __name: 'codeGroup',
  props: {
    elProp: null,
    code: null,
    mainTitle: { default: '未知' },
    title: { default: '未知' },
    index: { default: 0 },
    changeFormData: null,
    showConfig: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { elProp?: ElInputType, code: option, mainTitle: string, title: string, index: number, changeFormData: FunType, showConfig: boolean }


const code = ref<option>()
// 更新
function changeData(value: string, field: string) {
  props.changeFormData(field, value)
}

function translateLang(key: string) {
  return translate(key)
}

watch(
  () => props.code,
  () => {
    code.value = JSON.parse(JSON.stringify(props.code))
  },
  { immediate: true, deep: true }
)

return { __sfc: true,props, code, changeData, translateLang }
}

})